export const getConnectDUPRURL = (userId: string, moduleFor: string = 'p', cancelUrl?: string, successUrl?: string) => {
	const url = new URL(`https://${process.env.NEXT_PUBLIC_REWRITE_DOMAIN_NAME}/failed-membership?org=dupr&rsn=inv`);

	url.searchParams.append('mf', moduleFor);
	url.searchParams.append('uid', userId);

	if (cancelUrl) url.searchParams.append('cancelurl', encodeURI(cancelUrl));
	if (successUrl) url.searchParams.append('successurl', encodeURI(successUrl));

	return url.toString();
};
